import React, { useEffect } from 'react';
import './RotateWarning.css';

const RotateWarning = () => {
  return (
    <div className="rotate-warning">
      <p>Please open this app on a laptop or wider screen for the best experience.</p>
    </div>
  );
};

export default RotateWarning;
